module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_vm._l((_vm.quote.components), function(component) {
    return _c('div', {
      staticClass: "ui raised clearing segment component"
    }, [_c('a', {
      staticClass: "delete control",
      attrs: {
        "href": "#",
        "title": "Delete Component"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.confirmComponentRemoval(component)
        }
      }
    }, [_c('i', {
      staticClass: "large red remove link icon"
    })]), _vm._v(" "), _c('a', {
      staticClass: "reorder control",
      attrs: {
        "href": "#",
        "title": "Reorder Sections"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.reorder({
            target: 'sections',
            title: component.title,
            items: component.sections
          })
        }
      }
    }, [_c('i', {
      staticClass: "large sort link icon"
    })]), _vm._v(" "), _c('h2', [_c('span', {
      staticClass: "ui big blue circular label"
    }, [_vm._v(_vm._s(component.hours))]), _vm._v(" "), _c('div', {
      staticClass: "ui transparent input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (component.title),
        expression: "component.title"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(component.title)
      },
      on: {
        "change": _vm.updateQuote,
        "input": function($event) {
          if ($event.target.composing) { return; }
          component.title = $event.target.value
        }
      }
    })])]), _vm._v(" "), _vm._l((component.sections), function(section) {
      return _c('table', {
        staticClass: "section ui celled table"
      }, [_c('thead', [_c('tr', [_c('th', {
        staticClass: "title",
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "ui transparent input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (section.title),
          expression: "section.title"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": _vm._s(section.title)
        },
        on: {
          "change": _vm.updateQuote,
          "input": function($event) {
            if ($event.target.composing) { return; }
            section.title = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('th', {
        staticClass: "controls"
      }, [_c('a', {
        attrs: {
          "href": "#",
          "title": "Reorder Items"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.reorder({
              target: 'items',
              title: section.title,
              items: section.items
            })
          }
        }
      }, [_c('i', {
        staticClass: "sort link icon"
      })])]), _vm._v(" "), _c('th', {
        staticClass: "controls"
      }, [_c('a', {
        attrs: {
          "href": "#",
          "title": "Delete Section"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.confirmSectionRemoval(component, section)
          }
        }
      }, [_c('i', {
        staticClass: "red remove link icon"
      })])])])]), _vm._v(" "), _c('tbody', [_vm._l((section.items), function(item) {
        return _c('tr', {
          staticClass: "item"
        }, [_c('td', {
          staticClass: "description"
        }, [_c('div', {
          staticClass: "ui transparent input"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.title),
            expression: "item.title"
          }],
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": _vm._s(item.title)
          },
          on: {
            "change": _vm.updateQuote,
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.title = $event.target.value
            }
          }
        })])]), _vm._v(" "), _c('td', {
          staticClass: "type"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.type),
            expression: "item.type"
          }],
          staticClass: "ui fluid dropdown",
          on: {
            "change": [function($event) {
              item.type = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              })[0]
            }, _vm.updateQuote]
          }
        }, _vm._l((_vm.itemTypes), function(itemType) {
          return _c('option', {
            domProps: {
              "value": itemType.value
            }
          }, [_vm._v("\n                " + _vm._s(itemType.abbr) + "\n              ")])
        }))]), _vm._v(" "), _c('td', {
          staticClass: "hours"
        }, [_c('div', {
          staticClass: "ui transparent input"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model.number",
            value: (item.hours),
            expression: "item.hours",
            modifiers: {
              "number": true
            }
          }],
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": _vm._s(item.hours)
          },
          on: {
            "change": function($event) {
              _vm.calcSectionHours(component, section)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.hours = _vm._n($event.target.value)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })])]), _vm._v(" "), _c('td', {
          staticClass: "controls"
        }, [_c('a', {
          attrs: {
            "href": "#",
            "title": "Delete Item"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.confirmItemRemoval(component, section, item)
            }
          }
        }, [_c('i', {
          staticClass: "red remove link icon"
        })])])])
      }), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "description",
        attrs: {
          "colspan": "2"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "hours"
      }, [_c('strong', [_vm._v(_vm._s(section.hours))])]), _vm._v(" "), _c('td', {
        staticClass: "controls"
      }, [_c('a', {
        attrs: {
          "href": "#",
          "title": "Add Item"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.addItem(section)
          }
        }
      }, [_c('i', {
        staticClass: "green plus link icon"
      })])])])], 2)])
    }), _vm._v(" "), _c('button', {
      staticClass: "mini ui green right floated labeled icon button",
      on: {
        "click": function($event) {
          _vm.addSection(component)
        }
      }
    }, [_c('i', {
      staticClass: "plus icon"
    }), _vm._v("\n      SECTION\n    ")])], 2)
  }), _vm._v(" "), _c('button', {
    staticClass: "mini ui blue labeled icon button",
    attrs: {
      "title": "Reorder Components"
    },
    on: {
      "click": function($event) {
        _vm.reorder({
          target: 'components',
          title: 'Quote',
          items: _vm.quote.components
        })
      }
    }
  }, [_c('i', {
    staticClass: "sort icon"
  }), _vm._v("\n    COMPONENTS\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "mini ui blue labeled icon button",
    attrs: {
      "title": "Add Component"
    },
    on: {
      "click": _vm.addComponent
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v("\n    COMPONENT\n  ")]), _vm._v(" "), _c('modal-confirm', {
    attrs: {
      "payload": _vm.confirmPayload
    },
    on: {
      "confirm": _vm.remove
    }
  }), _vm._v(" "), _c('modal-reorder', {
    attrs: {
      "payload": _vm.reorderPayload
    },
    on: {
      "reorder": _vm.updateQuote,
      "close": _vm.reorderCleanup
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee511b72!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Editor.vue
// module id = 226
// module chunks = 2